import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import type {
  AdvanceOnboardingStepResponse,
  OnboardingStatus,
} from '../models/onboarding-status.model';

@Injectable({ providedIn: 'root' })
export class OnboardingApiService {
  private readonly http = inject(HttpClient);

  getStatus(): Observable<OnboardingStatus> {
    return this.http.get<OnboardingStatus>('/api/onboarding/status');
  }

  advance(targetStep?: number): Observable<AdvanceOnboardingStepResponse> {
    return this.http.post<AdvanceOnboardingStepResponse>('/api/onboarding/advance', {
      targetStep: targetStep ?? null,
    });
  }

  snooze(): Observable<void> {
    return this.http.post<void>('/api/onboarding/snooze', {});
  }

  skip(): Observable<void> {
    return this.http.post<void>('/api/onboarding/skip', {});
  }
}
